import script from "./LoaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=5f02114b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f02114b"]])

export default __exports__